import axios from "axios";

const axiosInstance = axios.create({
  timeout: 50000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// ✅ Request interceptor
axiosInstance.interceptors.request.use((config) => {
  // 🔥 IMPORTANT
  // If FormData → let browser set headers
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  console.log("➡️ Outgoing Request:", config);
  return config;
});

// ✅ Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 ||
        error.response.status === 403)
    ) {
      window.dispatchEvent(new Event("unauthorized"));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;